import useSWR from 'swr';
import api from '../services/api';

// TODO - paramaterize to support other countries when we need that
export const useStateGeoPlaces = () => {
  const { data, error } = useSWR('/v1/geo_places/regions?country=United%20States', api, {
    errorRetryCount: 3,
    revalidateOnFocus: false,
    shouldRetryOnError: false,
    onErrorRetry: (err, key, config, revalidate, revalidateOps) => {
      console.log({ err, config });
    },
  });
  return {
    loading: !data && !error,
    geoPlaces: data ? data.data.geo_places : null,
    error,
  };
};
